import AsyncStorage from "@react-native-async-storage/async-storage";
import { AuthTokenResponse } from "app/services/api/types/authorisation/responses/AuthTokenResponse";

const TOKEN_KEY = "auth";
export const storeToken = async (value: AuthTokenResponse): Promise<void> => {
  try {
    const finalValue = JSON.stringify(value);
    await AsyncStorage.setItem(TOKEN_KEY, finalValue);
  } catch (e) {
    console.error("Error saving token:", e);
  }
};

export const fetchToken = async (): Promise<AuthTokenResponse | null> => {
  try {
    const value = await AsyncStorage.getItem(TOKEN_KEY);
    if (!value) return null;
    return JSON.parse(value) as AuthTokenResponse;
  } catch (e) {
    console.error("Error fetching token:", e);
    return null;
  }
};

export const removeToken = async (): Promise<void> => {
  try {
    await AsyncStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    console.error("Error removing token:", e);
  }
};
